module.exports = __webpack_public_path__ + "static/media/numioDark.a1af4e03.png";